module.exports = __webpack_public_path__ + "img/ring_y_c_0_null@3x.6235141b.png";